var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"suaw-subheader"},[_c('div',{staticClass:"suaw-subheader__holder",class:'suaw-subheader__holder--' + _vm.size},[_c('Heading',{attrs:{"level":"2","content":_vm.headlineTitle}}),(_vm.headlineDesc)?_c('Paragraph',{attrs:{"text":_vm.headlineDesc,"alignment":_vm.descAlignment}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }